import _slicedToArray from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect, useState, useRef } from 'react';
import { SubmitButton } from '../components/SubmitButton';
import { FormikConsumer } from 'formik';
import { SAVED_TRANSITION_DELAY, SUBMITTED_TRANSITION_DELAY } from '../FormActions/FormActionsContainer';

function UncontrolledFormSubmitButton(_ref) {
  var id = _ref.id,
      _ref$formik = _ref.formik,
      isSubmitting = _ref$formik.isSubmitting,
      isValidating = _ref$formik.isValidating,
      isValid = _ref$formik.isValid,
      dirty = _ref$formik.dirty,
      status = _ref$formik.status,
      props = _objectWithoutProperties(_ref, ["id", "formik"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      recentlySaved = _useState2[0],
      setRecentlySaved = _useState2[1];

  var submittingRef = useRef(isSubmitting);
  useEffect(function () {
    if (submittingRef.current && !isSubmitting) {
      setRecentlySaved(true);
      var timeout = setTimeout(function () {
        setRecentlySaved(false);
      }, SAVED_TRANSITION_DELAY + SUBMITTED_TRANSITION_DELAY);
      return function () {
        clearTimeout(timeout);
      };
    }

    submittingRef.current = isSubmitting;
    return function () {};
  }, [isSubmitting, submittingRef]);
  return React.createElement(SubmitButton, Object.assign({
    id: id,
    isBusy: isValidating || isSubmitting,
    isValid: isValid && (!status || !status.hasError),
    recentlySaved: recentlySaved
  }, props));
}

export function FormSubmitButton(props) {
  return React.createElement(FormikConsumer, null, function (formik) {
    return React.createElement(UncontrolledFormSubmitButton, Object.assign({
      formik: formik
    }, props));
  });
}